/** GameRegistry — 一处统一查 per-game scene config */
import type { GameId } from '@sss/shared'
import type { GameSceneConfig } from './types'
import { CANDY_SCENE_CONFIG } from './candy/manifest'
import { SAKURA_SCENE_CONFIG } from './sakura/manifest'

export const GameRegistry: Record<GameId, GameSceneConfig> = {
  candy: CANDY_SCENE_CONFIG,
  sakura: SAKURA_SCENE_CONFIG,
}

export type { GameSceneConfig } from './types'
